import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowRight, HelpCircle, CreditCard } from "lucide-react";

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="grain">
      <Navbar />
      <section className="relative min-h-[75vh] py-16">
        <div className="forge-glow absolute inset-0" />
        <div className="relative mx-auto max-w-2xl px-4 sm:px-6">
          <div className="rounded-3xl border border-border bg-card p-10 text-center">
            <div className="mx-auto inline-flex h-16 w-16 items-center justify-center rounded-full bg-secondary text-muted-foreground">
              <XCircle className="h-9 w-9" />
            </div>
            <h1 className="display-font mt-4 text-3xl font-bold">Checkout canceled.</h1>
            <p className="mt-2 text-sm text-muted-foreground">No charge was made. You can pick your plan again anytime.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Button className="btn-ember h-11 gap-2 px-5 font-semibold" onClick={() => navigate("/pricing")}>
                <CreditCard className="h-4 w-4" /> Back to pricing
              </Button>
              <Button variant="outline" className="h-11" onClick={() => navigate("/contact")}><HelpCircle className="mr-2 h-4 w-4" /> Need help paying?</Button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
